<template>
  <div class="wrapper">
    <Card class="m-b steps">
      <Steps :current="currentStep - 1">
        <Step title="店铺信息"
              content="填写基本店铺信息"></Step>
        <Step title="负责人信息"
              content="填写负责人信息"></Step>
        <Step title="财务信息"
              content="填写财务信息"></Step>
      </Steps>
    </Card>
    <Card class="m-b">
      <Modal v-model="modalShow"
             @on-ok="handleSubmit"
             title="选择已通过的商户的资质">
        <Table style="margin-top: 20px;"
               border
               :loading="loading"
               :columns="columns"
               :data="shops"></Table>
      </Modal>
      <!-- <i-form>
        <Form-item label="快速通道">
          <el-button size="medium"
                     class="filter-item"
                     type="primary"
                     @click.prevent="searchBtnClick()">选择已通过的商户的资质</el-button>
        </Form-item>
      </i-form> -->
    </Card>
    <Card class="form">
      <Form ref="lcsw_account"
            :rules="rules"
            :model="lcsw_account"
            :label-width="200">
        <Form-item label="状态"
                   prop="status"
                   v-if="lcsw_account.status">
          <!-- <Input disabled type="text" v-model="lcsw_account.status" /> -->
          <span style="color: green">{{ lcsw_account.status }}</span>
        </Form-item>
        <div v-if="lcsw_account.status !== '已开通'">
          <template v-if="currentStep === 1">
            <Form-item label="商户性质"
                       prop="merchant_business_type">
              <Select label-in-value
                      @on-change="change_merchant_business_type">
                <Option v-for="item in merchant_business_types"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item label="店铺名称"
                       prop="merchant_name">
              <Input type="text"
                     v-model="lcsw_account.merchant_name" />
            </Form-item>
            <Form-item label="店铺简称"
                       prop="merchant_alias">
              <Input type="text"
                     v-model="lcsw_account.merchant_alias" />
            </Form-item>
            <Form-item label="商户注册名称/公司全称"
                       prop="merchant_company">
              <Input type="text"
                     v-model="lcsw_account.merchant_company" />
            </Form-item>
            <Form-item label="所在省份"
                       prop="merchant_province_code">
              <Select label-in-value
                      :value="lcsw_account.merchant_province_code"
                      @on-change="change_province">
                <Option v-for="item in provinces"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item label="所在城市"
                       prop="merchant_city_code">
              <Select label-in-value
                      :value="lcsw_account.merchant_city_code"
                      @on-change="change_city">
                <Option v-for="item in cities"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item label="所在区县"
                       prop="merchant_county_code">
              <Select label-in-value
                      :value="lcsw_account.merchant_county_code"
                      @on-change="change_county">
                <Option v-for="item in counties"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item label="所属行业"
                       prop="business_code">
              <Select label-in-value
                      @on-change="change_business_code">
                <Option v-for="item in industries"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item label="营业执照注册号或者社会信用代码"
                       prop="license_no">
              <Input type="text"
                     v-model="lcsw_account.license_no" />
            </Form-item>
            <Form-item label="营业证件类型"
                       prop="license_type">
              <Select label-in-value
                      @on-change="change_license_type">
                <Option v-for="item in license_types"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item label="商户详细地址"
                       prop="merchant_address">
              <Input type="text"
                     v-model="lcsw_account.merchant_address" />
            </Form-item>
            <Form-item label="门头照片"
                       prop="remote_img_logo_url">
              <uploader @uploadedUrl="uploadedUrl_img_logo"
                        :url="lcsw_account.remote_img_logo_url"></uploader>
            </Form-item>
            <Form-item label="门脸(内设)照片(前台)"
                       prop="remote_img_indoor_url">
              <uploader @uploadedUrl="uploadedUrl_img_indoor"
                        :url="lcsw_account.remote_img_indoor_url"></uploader>
            </Form-item>
            <Form-item label="营业执照照片"
                       prop="remote_img_license_url">
              <uploader @uploadedUrl="uploadedUrl_img_license"
                        :url="lcsw_account.remote_img_license_url"></uploader>
            </Form-item>
            <Form-item label="组织机构代码证照片(非三证合一)"
                       prop="remote_img_org_code_url">
              <uploader @uploadedUrl="uploadedUrl_img_org_code"
                        :url="lcsw_account.remote_img_org_code_url"></uploader>
            </Form-item>
          </template>

          <template v-if="currentStep === 2">
            <!-- <Form-item label="联系人"
                       prop="account_name">
              <Input type="text"
                     v-model="lcsw_account.account_name" />
            </Form-item> -->
            <Form-item label="法人姓名"
                       prop="artif_nm">
              <Input type="text"
                     v-model="lcsw_account.artif_nm" />
            </Form-item>
            <Form-item label="法人身份证号码"
                       prop="legalIdnum">
              <Input type="text"
                     v-model="lcsw_account.legalIdnum" />
            </Form-item>
            <Form-item label="商户负责人"
                       prop="merchant_person">
              <Input type="text"
                     v-model="lcsw_account.merchant_person" />
            </Form-item>
            <Form-item label="负责人电话"
                       prop="merchant_phone">
              <Input type="text"
                     v-model="lcsw_account.merchant_phone" />
            </Form-item>
            <Form-item label="联系邮箱"
                       prop="merchant_email">
              <Input type="text"
                     v-model="lcsw_account.merchant_email" />
            </Form-item>
            <Form-item label="法人身份证正面照片"
                       prop="remote_img_idcard_a_url">
              <uploader @uploadedUrl="uploadedUrl_img_idcard_a"
                        :url="lcsw_account.remote_img_idcard_a_url"></uploader>
            </Form-item>
            <Form-item label="法人身份证反面照片"
                       prop="remote_img_idcard_b_url">
              <uploader @uploadedUrl="uploadedUrl_img_idcard_b"
                        :url="lcsw_account.remote_img_idcard_b_url"></uploader>
            </Form-item>
            <Form-item label="本人手持身份证照片"
                       prop="remote_img_idcard_holding_url">
              <uploader @uploadedUrl="uploadedUrl_img_idcard_holding"
                        :url="lcsw_account.remote_img_idcard_holding_url"></uploader>
            </Form-item>
          </template>

          <template v-if="currentStep === 3">
            <Form-item label="结算人证件号码"
                       prop="merchant_id_no">
              <Input type="text"
                     v-model="lcsw_account.merchant_id_no" />
            </Form-item>
            <Form-item label="结算方式">
              <Input type="text"
                     readonly
                     value="结算到银行卡" />
            </Form-item>
            <Form-item label="账户类型"
                       prop="account_type">
              <Select label-in-value
                      v-model="lcsw_account.account_type">
                <Option v-for="item in account_types"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item label="结算类型"
                       prop="settlement_type">
              <Select label-in-value
                      v-model="lcsw_account.settlement_type">
                <Option v-for="item in settlement_types"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item label="清算类型"
                       prop="settle_type">
              <Select label-in-value
                      v-model="lcsw_account.settle_type">
                <Option v-for="item in settle_types"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item label="自动清算金额"
                       prop="settle_amount">
              <Input type="text"
                     v-model="lcsw_account.settle_amount"
                     placeholder="自动清算金额（单位分），清算类型为自动清算时有效，指帐户余额达到此值才清算。" />
            </Form-item>
            <Form-item label="所属银行"
                       prop="bank_name">
              <Select label-in-value
                      @on-change="change_bank"
                      filterable
                      remote
                      :remote-method="net_banks_index"
                      placeholder="关键词搜索（如中山路/城西…)">
                <Option v-for="item in net_banks"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item label="持卡人姓名"
                       prop="account_name">
              <Input type="text"
                     v-model="lcsw_account.account_name" />
            </Form-item>
            <Form-item label="银行卡号"
                       prop="account_no">
              <Input type="text"
                     v-model="lcsw_account.account_no" />
            </Form-item>
            <Form-item label="入账银行卡正面照片"
                       prop="remote_img_bankcard_a_url">
              <uploader @uploadedUrl="uploadedUrl_img_bankcard_a"
                        :url="lcsw_account.remote_img_bankcard_a_url"></uploader>
            </Form-item>
            <Form-item label="开户许可证照片"
                       prop="remote_img_open_permits_url">
              <uploader @uploadedUrl="uploadedUrl_img_open_permits"
                        :url="lcsw_account.remote_img_open_permits_url"></uploader>
            </Form-item>
            <Form-item label="对私账户身份证正面照片"
                       prop="remote_img_private_idcard_a_url">
              <uploader @uploadedUrl="uploadedUrl_img_private_idcard_a"
                        :url="lcsw_account.remote_img_private_idcard_a_url"></uploader>
            </Form-item>
            <Form-item label="对私账户身份证反面照片"
                       prop="remote_img_private_idcard_b_url">
              <uploader @uploadedUrl="uploadedUrl_img_private_idcard_b"
                        :url="lcsw_account.img_private_idcard_b && lcsw_account.img_private_idcard_b.url"></uploader>
            </Form-item>
            <Form-item label="入账非法人证明照片"
                       prop="remote_img_unincorporated_url">
              <uploader @uploadedUrl="uploadedUrl_img_unincorporated"
                        :url="lcsw_account.remote_img_unincorporated_url"></uploader>
            </Form-item>
          </template>

          <Form-item>
            <Button class="m-r"
                    type="default"
                    v-if="currentStep > 1"
                    html-type="button"
                    @click="prevStep">上一页</Button>
            <Button class="m-r"
                    type="default"
                    v-if="currentStep < 3"
                    html-type="button"
                    @click="nextStep">下一页</Button>
            <Button type="primary"
                    v-if="currentStep === 3"
                    html-type="button"
                    @click="handleSubmit">提交</Button>
          </Form-item>
        </div>
      </Form>
    </Card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Uploader from '@/components/uploader-aliyun/single'
import {
  commonButtonInTable
} from '@/libs/table-render'

const LS_KEY_LCSW_ACCOUNT = 'LS_KEY_LCSW_ACCOUNT'

export default {
  components: {
    Uploader
  },
  data () {
    return {
      currentStep: 1,
      modalShow: false,
      columns: [
        {
          title: '店铺名',
          key: 'name'
        },
        {
          title: '在线支付',
          width: 120,
          align: 'center',
          key: 'lcsw_account_status'
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          render: (h, params) => {
            const children = []
            if (params.row.lcsw_account_status === '已开通') {
              children.push(
                commonButtonInTable(
                  this,
                  h,
                  'warning',
                  '选择',
                  this.shop_select,
                  [params.row.id]
                )
              )
            }
            return h('div', children)
          }
        }
      ],
      merchant_business_types: [
        { text: '个人申请', code: '3' },
        { text: '营业执照个体工商户', code: '2' },
        { text: '营业执照有限公司', code: '1' }
      ],
      settle_types: [
        { text: '手动结算', code: '2' },
        { text: '自动结算', code: '1' }
      ],
      settlement_types: [
        { text: '法人结算', code: '1' },
        { text: '非法人结算', code: '2' }
      ],
      account_types: [
        { text: '对私', code: '2' },
        { text: '对公', code: '1' }
      ],
      license_types: [
        { text: '手持身份证', code: '2' },
        { text: '三证合一', code: '1' },
        { text: '营业执照', code: '0' }
      ]
    }
  },
  async created () {
    await this.find_one()
    this.province_index()
    this.industries_index()
    this.$nextTick(() => {
      if (!this.lcsw_account.id) {
        const local = this.getLocal()
        this.set_record(local)
        if (local) {
          if (local.merchant_province_code) {
            this.cities_index(local.merchant_province_code)
          }
          if (local.merchant_city_code) {
            this.counties_index(local.merchant_city_code)
          }
        }
      } else {
        this.clearLocal()
      }
    })
  },
  computed: {
    ...mapGetters('lcsw_account', [
      'lcsw_account',
      'loading',
      'provinces',
      'cities',
      'counties',
      'net_banks',
      'industries'
    ]),
    ...mapGetters('shop', ['shops', 'meta', 'loading']),
    rules () {
      console.log('this.merchant_business_types', this.merchant_business_types)
      const MICRO_CO = '3' // 小微企业
      const SINGLE = '2' // 个体户
      const COMPANY = '1' // 公司
      const requiredFields = [
        { key: 'merchant_name', title: '店铺名称', step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_alias', title: '店铺简称', step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'license_type', title: '营业证件类型', step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'business_code', title: '所属行业', step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_province_code', title: '所在省份', step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_city_code', title: '所在城市', step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_county_code', title: '所在区县', step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_address', title: '商户详细地址', step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_business_type', title: '商户性质', step: 1 },
        { key: 'remote_img_license_url', title: '营业执照照片', step: 1, business_type: [COMPANY, SINGLE] },
        { key: 'remote_img_org_code_url', title: '组织机构代码证照片', step: 1, business_type: [COMPANY] },
        { key: 'remote_img_indoor_url', title: '门脸照片', step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'license_no', title: '营业执照注册号或者社会信用代码', step: 1, business_type: [COMPANY] },
        { key: 'account_name', title: '持卡人姓名', step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_person', title: '商户负责人', step: 2, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'artif_nm', title: '法人姓名', step: 2, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'legalIdnum', title: '法人身份证号码', step: 2, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'img_idcard_a', title: '法人身份证证明照片', step: 2, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'img_idcard_b', title: '法人身份证反面照片', step: 2, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_phone', title: '负责人电话', step: 2, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'img_idcard_holding', title: '本人手持身份证照片', step: 2, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'account_no', title: '银行卡号', step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'account_type', title: '账户类型', step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'img_bankcard_a', title: '入账银行卡正面照片', step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'settle_type', title: '清算类型', step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'settle_amount', title: '自动清算金额', step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'settlement_type', title: '结算类型', step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_id_no', title: '结算人证件号码', step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'img_open_permits', title: '开户许可证照片', step: 3, business_type: [COMPANY] },
        { key: 'img_private_idcard_a', title: '对私账户身份证正面照片', step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'img_private_idcard_b', title: '对私账户身份证反面照片', step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'img_unincorporated', title: '入账非法人证明照片', step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_email', title: '联系邮箱', step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'bank_name', title: '所属银行', step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] }
      ]
      const rules = {}
      requiredFields.filter(i => {
        if (!i.business_type) return true
        console.log('this.lcsw_account.merchant_business_type', this.lcsw_account.merchant_business_type, i.business_type)
        return i.business_type.includes(this.lcsw_account.merchant_business_type)
      }).forEach((i) => {
        rules[i.key] = [{
          required: i.step === this.currentStep,
          validator: (rule, value, callback) => {
            if (i.step !== this.currentStep) {
              callback()
            } else if (!this.lcsw_account[i.key]) {
              callback(new Error(i.title + '不能为空'))
            } else {
              callback()
            }
          }
        }]
      })
      if (this.currentStep === 3 && this.lcsw_account.settle_type === '1') {
        rules.settle_amount = [{ required: true, message: '自动清算金额不能为空' }]
      }
      if (this.currentStep === 1) {
        rules.merchant_business_type = [{ required: true, message: '请选择商户性质' }]
      }
      console.log('rules:', rules)
      return rules
    }
  },
  methods: {
    ...mapActions('lcsw_account', [
      'counties_index',
      'find_one',
      'grant',
      'province_index',
      'cities_index',
      'net_banks_index',
      'industries_index',
      'create',
      'destroy',
      'update',
      'set_record'
    ]),
    ...mapActions('shop', [
      'clear',
      'index'
    ]),
    searchBtnClick () {
      this.index()
      this.modalShow = true
    },
    shop_select (shop_id) {
      this.grant({ shop_id })
      this.modalShow = false
    },
    async change_province (e) {
      e = e || {}
      if (e.value !== this.lcsw_account.merchant_province_code) {
        this.lcsw_account.merchant_province = e.label
        this.lcsw_account.merchant_province_code = e.value
        e.value && this.cities_index(e.value)
        this.lcsw_account.merchant_city = ''
        this.lcsw_account.merchant_city_code = ''
      }
    },
    change_city (e) {
      e = e || {}
      if (e.value !== this.lcsw_account.merchant_city_code) {
        this.lcsw_account.merchant_city = e.label
        this.lcsw_account.merchant_city_code = e.value
        e.value && this.counties_index(e.value)
        this.lcsw_account.merchant_county = ''
        this.lcsw_account.merchant_county_code = ''
      }
    },
    change_county (e) {
      e = e || {}
      this.lcsw_account.merchant_county = e.label
      this.lcsw_account.merchant_county_code = e.value
    },
    change_net_bank (e) {
      this.lcsw_account.merchant_county = e.label
    },
    change_bank (e) {
      this.lcsw_account.bank_name = e.label
      this.lcsw_account.bank_no = e.value
    },
    change_merchant_business_type (e) {
      this.$set(this.lcsw_account, 'merchant_business_type', e.value)
      // this.lcsw_account.merchant_business_type = e.value
    },
    change_business_code (e) {
      this.lcsw_account.business_code = e.value
    },
    change_license_type (e) {
      this.lcsw_account.license_type = e.value
    },
    async handleSubmit () {
      try {
        if (this.lcsw_account.id) {
          await this.update(this.lcsw_account)
        } else {
          await this.create(this.lcsw_account)
        }
        this.clearLocal()
      } catch (e) {
        //
      }
    },
    uploadedUrl_img_idcard_a (url) {
      this.lcsw_account.remote_img_idcard_a_url = url
    },
    uploadedUrl_img_idcard_b (url) {
      this.lcsw_account.remote_img_idcard_b_url = url
    },
    uploadedUrl_img_bankcard_a (url) {
      this.lcsw_account.remote_img_bankcard_a_url = url
    },
    uploadedUrl_img_open_permits (url) {
      this.lcsw_account.remote_img_open_permits_url = url
    },
    uploadedUrl_img_logo (url) {
      this.lcsw_account.remote_img_logo_url = url
    },
    uploadedUrl_img_indoor (url) {
      this.lcsw_account.remote_img_indoor_url = url
    },
    uploadedUrl_img_license (url) {
      this.lcsw_account.remote_img_license_url = url
    },
    uploadedUrl_img_org_code (url) {
      this.lcsw_account.remote_img_org_code_url = url
    },
    uploadedUrl_img_private_idcard_a (url) {
      this.lcsw_account.remote_img_private_idcard_a_url = url
    },
    uploadedUrl_img_private_idcard_b (url) {
      this.lcsw_account.remote_img_private_idcard_b_url = url
    },
    uploadedUrl_img_idcard_holding (url) {
      this.lcsw_account.remote_img_idcard_holding_url = url
    },
    uploadedUrl_img_unincorporated (url) {
      this.lcsw_account.remote_img_unincorporated_url = url
    },
    nextStep () {
      this.$refs.lcsw_account.validate(valid => {
        if (valid) {
          this.saveLocal()
          this.currentStep = Math.min(this.currentStep + 1, 3)
        } else {
          this.$refs.lcsw_account.$el.scrollIntoView()
        }
      })
    },
    prevStep () {
      this.currentStep = Math.max(1, this.currentStep - 1)
    },
    saveLocal () {
      try {
        sessionStorage.setItem(LS_KEY_LCSW_ACCOUNT, JSON.stringify(this.lcsw_account))
      } catch (e) {
        // skip
      }
    },
    getLocal () {
      const serialized = sessionStorage.getItem(LS_KEY_LCSW_ACCOUNT)
      if (serialized) {
        return JSON.parse(serialized)
      }
      return {}
    },
    clearLocal () {
      sessionStorage.clearLocal(LS_KEY_LCSW_ACCOUNT)
    }
  }
}
</script>

<style lang="scss" scoped>
.m-b {
  margin-bottom: 12px;
}
.m-r {
  margin-right: 12px;
}
.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.steps {
  flex: 0 0 auto;
}
.form {
  flex: auto;
  overflow: auto;
}
</style>
